import React from 'react'
import Accordions from "../../../components/Accordions";


const Sem8Ecce1 = () =>{
  const data = [
    // {
    //   subjectName: "2023 Batch",
    //   units: [ ],
    //   links: [
    //     {
    //       url: "",
    //       title: "Syllabus",
    //     },
    //   ],
    // },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">EFE Sem - 8</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem8Ecce1